import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "entry-animation" }
const _hoisted_2 = { class: "mt-12 md:mt-20 mb-8 text-center" }
const _hoisted_3 = { class: "mb-1 text-md font-bold leading-tight" }
const _hoisted_4 = { class: "text-base-200" }
const _hoisted_5 = { class: "mx-auto mb-12 md:mb-20 w-full max-w-[300px]" }
const _hoisted_6 = {
  key: 0,
  class: "max-w-[520px] mx-auto"
}
const _hoisted_7 = { class: "text-info-900" }

import { inject, onMounted, ref } from 'vue';
import Button from '../base/Button.vue';
import TextInput from '../form/TextInput.vue';
import { AppConfigType, ScheduleType } from '~src/admin/types';
import Card from '../layout/Card.vue';
import { useRouter } from 'vue-router';
import Axios from '~src/shared/axios';
import { useNotificationStore } from '~src/admin/stores/useNotificationStore';
import { useGettext } from 'vue3-gettext';

// Translations

export default /*@__PURE__*/_defineComponent({
  __name: 'Subject',
  props: {
    schedule: {},
    isFirstSchedule: { type: Boolean }
  },
  emits: ["nextStep", "updateSchedule"],
  setup(__props: any, { emit: __emit }) {

const { $gettext } = useGettext();

// Get plugin config
const config: AppConfigType = inject('pluginConfig');

// Router
const router = useRouter();

// Show notification
const { addNotification } = useNotificationStore();

// Loading
const loading = ref(false);

// Props


// Emits
const emit = __emit;

// Topic value
const selectedTopic = ref(__props.schedule.topic || '');

// Error handling
const errorMsg = ref('');

// Try to get the topic from the API
onMounted(async () => {
    try {
        // Set loading
        loading.value = true;

        // Call the WordPress Rest API to generate topic
        const response = await Axios.get(`${config.rest.endpoints.boostsite}/generate_topic`);

        // Check if the response is successful
        if (response.status !== 200 || !response.data.success) {
            throw new Error(`REST API error: ${response.status} - ${response.statusText}`);
        }

        // Show the generated topic
		if (response?.data?.data?.data) {
			selectedTopic.value = response.data.data.data;
		}
    } catch (error) {
        console.error('Error generating while topic:', error);

        addNotification({
            message: $gettext('There was an error while generating the topic!'),
            type: 'danger',
        });
    } finally {
        // Set loading
        loading.value = false;
    }
});

// Go to next step
const goToNextStep = () => {
    errorMsg.value = '';

    // Topic validation
    if (!selectedTopic.value) {
        errorMsg.value = $gettext('Please provide subject.');
        return;
    }

    // Update the schedule
    const newSchedule = {
        ...__props.schedule,
        topic: selectedTopic.value,
    };

    emit('updateSchedule', newSchedule);

    // Go to next step and update the schedule
    emit('nextStep');
};

// Set texts based on if schedule is first or not
let title = $gettext('What is a topic of your website?');
let subtitle = $gettext('We will use it later to generate articles. You can always change it later in settings.');

if (!__props.isFirstSchedule) {
    title = $gettext('What should articles be about?');
    subtitle = $gettext('Describe the subject of the articles.');
}

// Account type
const isAccountFree = inject<boolean>('isAccountFree');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_unref(title)), 1),
      _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(subtitle)), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(TextInput, {
        class: "mb-6 md:mb-10",
        placeholder: _unref($gettext)('e.g. furniture'),
        modelValue: selectedTopic.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedTopic).value = $event)),
        "error-msg": errorMsg.value,
        disabled: loading.value
      }, null, 8, ["placeholder", "modelValue", "error-msg", "disabled"]),
      _createVNode(Button, {
        class: "w-full",
        text: _unref($gettext)('Next'),
        size: "large",
        onClick: _withModifiers(goToNextStep, ["prevent"]),
        loading: loading.value
      }, null, 8, ["text", "loading"])
    ]),
    (_unref(isAccountFree))
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(Card, {
            "image-url": `${_unref(config).plugin_url}/public/images/first-schedule.png`,
            "image-alt": _unref($gettext)('Upgrade to premium plan')
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_7, [
                _createTextVNode(_toDisplayString(_unref($gettext)('Need more topics or key words?')) + " ", 1),
                _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
                _createElementVNode("a", {
                  href: "#",
                  class: "underline underline-offset-[3px]",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(() => _unref(router).push('/upgrade'), ["prevent"]))
                }, _toDisplayString(_unref($gettext)('Upgrade')), 1),
                _createTextVNode(" " + _toDisplayString(_unref($gettext)('to our paid plan to unlock powerful features.')), 1)
              ])
            ]),
            _: 1
          }, 8, ["image-url", "image-alt"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})